export const SAVE_INFORMATION = 'SAVE_INFORMATION';
export const SAVE_INFORMATION_SUCCESS = 'SAVE_INFORMATION_SUCCESS';
export const SAVE_INFORMATION_FAILURE = 'SAVE_INFORMATION_FAILURE';
export const ADD_INFORMATION_TO_THE_LIST = 'ADD_INFORMATION_TO_THE_LIST';
export const UPDATE_INFORMATION_IN_THE_LIST = 'UPDATE_INFORMATION_IN_THE_LIST';



// WEBPACK FOOTER //
// ./src/modules/InformationForm/actionTypes.js